var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H49V50H0V0Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.293 20.293C27.4805 20.1056 27.7348 20.0002 28 20.0002C28.2652 20.0002 28.5195 20.1056 28.707 20.293L33.207 24.793C33.3945 24.9806 33.4998 25.2349 33.4998 25.5C33.4998 25.7652 33.3945 26.0195 33.207 26.207L28.707 30.707C28.5184 30.8892 28.2658 30.99 28.0036 30.9877C27.7414 30.9854 27.4906 30.8803 27.3052 30.6948C27.1198 30.5094 27.0146 30.2586 27.0123 29.9964C27.01 29.7342 27.1108 29.4816 27.293 29.293L30 26.5H20.5C20.2348 26.5 19.9804 26.3947 19.7929 26.2071C19.6054 26.0196 19.5 25.7652 19.5 25.5C19.5 25.2348 19.6054 24.9805 19.7929 24.7929C19.9804 24.6054 20.2348 24.5 20.5 24.5H30L27.293 21.707C27.1055 21.5195 27.0002 21.2652 27.0002 21C27.0002 20.7349 27.1055 20.4806 27.293 20.293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.a2b103c7acec750c709e98208c765962.svg";
export { ForwardRef as ReactComponent };